import React from "react";
import DirectionsWalk from "@mui/icons-material/DirectionsWalk";

export default function DirectionsWalkIcon(props) {
  return <DirectionsWalk {...props} />;
}
